import { QueryClient } from "@tanstack/react-query";
import { getCurrentUser } from "aws-amplify/auth";
import { redirect } from "react-router";
import { getRouteTreeRoot } from "~/shared/api/users/users.helpers";
import { getUserType } from "~/shared/api/users/users.queries";

export async function loginLoader(queryClient: QueryClient) {
  try {
    const currentAuthenticatedUser = await getCurrentUser();
    if (currentAuthenticatedUser) {
      try {
        const userType = await getUserType(queryClient);
        const routeTreeRoot = getRouteTreeRoot(userType);

        // Redirect to home if user is already logged in
        return redirect(routeTreeRoot);
      } catch (_error) {
        return null;
      }
    }

    return null;
  } catch (_error) {
    return null;
  }
}
